import Dexie from 'dexie'

export const pubhubIndexedDb = new Dexie('pubhubDb')

pubhubIndexedDb.version(1).stores({
  publications: 'ditaId' // Primary key and indexed props
})
